var user = {
  init: function() {
  },
  deleteSubaccount: function( sid ) {
    
  }
}
